import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'
import storeHelper from '@/store/helper'

import FileDownload from 'js-file-download'
import moment from 'moment'

export class CalendarAfsService extends BaseService {
  // NHÓM CÔNG VIỆC
  static async groupCalendar(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.wkgroup.list'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async detailGroupCalendar(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.wkgroup.detail'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async addGroupCalendar(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.wkgroup.insert'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async editGroupCalendar(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.wkgroup.update'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async lockGroupCalendar(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.wkgroup.lock'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async unlockGroupCalendar(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.wkgroup.unlock'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportGroupCalendar(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.wkgroup.export'),
        params,
        {
          responseType: 'blob',
        }
      )

      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'Nhom_CV_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async importGroupCalendar(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.wkgroup.import-data'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // lịch sử import nhóm cv
  static async historyImportGroupCalendar(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.wkgroup.history-import'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // dowload file mẫu nhóm cv
  static async downloadTemplateGrCalendar(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.wkgroup.import-template'),
        params,
        {
          responseType: 'blob',
        }
      )
      console.log(response)
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(
        response.data,
        'File_mau_NhomCV' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // DANH MỤC CÔNG VIỆC
  static async catCalendar(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.wktask.list'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async detailCatCalendar(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.wktask.detail'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async addCatCalendar(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.wktask.insert'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async editCatCalendar(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.wktask.update'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async lockCatCalendar(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.wktask.lock'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async unlockCatCalendar(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.wktask.unlock'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // export excel danh mục cv
  static async exportCatCalendar(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.wktask.export'),
        params,
        {
          responseType: 'blob',
        }
      )

      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'Danh_muc_CV_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // import dạnh mục cv
  static async importCatCalendar(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.wktask.import-data'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // lịch sử import danh mục cv
  static async historyImportCatCalendar(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.wktask.import-data'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // dowload file mẫu danh mục cv
  static async downloadTemplateCatCalendar(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.wktask.import-template'),
        params,
        {
          responseType: 'blob',
        }
      )
      console.log(response)
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(
        response.data,
        'File_mau_Danh_muc_CV' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // CÔNG VIỆC
  static async getTaskAFS(body = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.list-on-web'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getTaskAFSDetailById(body = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.detail'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async addCalendarAFS(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.insert'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async EditCalendarAFS(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.update'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportExcelCalendarAFS(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.export'),
        params,
        {
          responseType: 'blob',
        }
      )

      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'Calendar-work-AFS' + ' ' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async exportReportCalendarAFS(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.download.report'),
        params,
        {
          responseType: 'blob',
        }
      )

      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }

      FileDownload(
        response.data,
        'Calendar-Report-AFS' + ' ' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xls'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async cancelCalendarAFS(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.cancel'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async UpdateCalendarAFS(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.evaluate'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getWorkSubsection(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.css.sub-category-task.list'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getSubCategoryTask(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.css.sub-category-task.list'),
        params
      )
      return response.data
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getDetailWorkSubsection(id) {
    try {
      const response = await this.request({ auth: true }).get(
        storeHelper.getUrl('cnps.css.sub-category-task.detail').replace('{id}', id)
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async addWorkSubsection(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.css.sub-category-task.create'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async updateWorkSubsectionStatus(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.css.sub-category-task.lock-unlock'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
}
